export default function draw (m, p, ctx) {
	return t => {
	let v = m(t);
	ctx.clearRect(0,0,p.width,p.height);
	ctx.beginPath();
	for ( let item, i = 0, len = v.length; i < len; i++) {
		item = v[i];
		if (item.moveTo) {
			ctx.moveTo(item.x, item.y);
		} else if (item.curve && item.curve.type === 'cubic') {
			ctx.bezierCurveTo(item.curve.x1, item.curve.y1, item.curve.x2, item.curve.y2, item.x, item.y);
		} else if (item.curve && item.curve.type === 'quadratic') {
			ctx.quadraticCurveTo(item.curve.x1, item.curve.y1, item.x, item.y);
		} else {
			ctx.lineTo(item.x, item.y);
		}
	}
	ctx.strokeStyle = p.fill || '#555'
	ctx.stroke();
	}
};
